import { Base } from '@studiometa/js-toolkit';

/**
 * MapFrance component
 */
export default class MapFrance extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'MapFrance',
  };

  /**
   *
   */
  mounted() {
    this.addRegionLabels(this.$el);
  }

  /**
   *
   * @param {*} pathElement
   * @returns {object}
   */
  getPathCenter(pathElement) {
    const pathLength = pathElement.getTotalLength();
    let xSum = 0;
    let ySum = 0;
    const numPoints = 100;

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i <= numPoints; i++) {
      const point = pathElement.getPointAtLength((i / numPoints) * pathLength);
      xSum += point.x;
      ySum += point.y;
    }

    return { x: xSum / numPoints, y: ySum / numPoints };
  }

  /**
   *
   * @param {HTMLElement} svgElement
   */
  addRegionLabels(svgElement) {
    const paths = svgElement.querySelectorAll('path');

    paths.forEach((path) => {
      const center = this.getPathCenter(path);
      const regionText = path.dataset.text;

      const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      text.setAttribute('x', center.x);
      text.setAttribute('y', center.y);
      text.setAttribute('class', 'region-label');
      text.setAttribute('text-anchor', 'middle');
      text.setAttribute('dominant-baseline', 'middle');
      text.style.fill = 'white';
      text.style.fontSize = '14px';
      text.textContent = regionText;

      path.after(text);
    });
  }
}
